var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footerq"},[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column is-three-quarters"},[_c('p',[_vm._v(_vm._s((new Date()).getFullYear())+" Reguity Group AB (publ)")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }